module.exports = __webpack_public_path__ + "static/media/banner_dem_sat.439a6236.jpg";